import "./App.css";
import { AuthProvider, useAuthContext } from "@hooks/context/useAuthContext";
import ErrorBoundary from "./views/ErrorBoundary/ErrorBoundary";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Navigate, Route, Routes } from "react-router-dom";
import { RouteInfo, getRoutes } from "routes/routes";
import ScrollToTop from "@stories/atoms/ScrollToTop/ScrollToTop";
import { Amplify, Auth } from "aws-amplify";
import { browserStorage } from "@utils/browserStorage";
import ThemeCustomization from "themes";
import { ToastContainer } from "react-toastify";
import Locales from "@stories/ui-component/Locales";
import "react-toastify/dist/ReactToastify.css";
const region = "ap-southeast-2";
export const API_END_POINT = "https://vcn8bocr8k.execute-api.ap-southeast-2.amazonaws.com/dev/";
export const API_END_POINT_GEO = "https://1d4445dgtk.execute-api.ap-southeast-2.amazonaws.com/dev/";
export const BUCKET_NAME = "storagestack-databucketd8691f4e-1uook8mxjix4w";

Amplify.configure({
  Auth: {
    region: region,
    identityPoolId: "ap-southeast-2:e6f5e28e-36f5-4639-a232-82290ba3f125",
    userPoolId: "ap-southeast-2_Iv7osIMVJ",
    userPoolWebClientId: "bd1v76kbj1rbkhjn2udku7995",
    authenticationFlowType: "CUSTOM_AUTH",
    mandatorySignIn: true,
    storage: browserStorage,
  },
  Storage: {
    customPrefix: {
      public: "",
      private: "",
      protected: "",
    },
    AWSS3: {
      bucket: BUCKET_NAME,
      region: region,
    },
  },
  API: {
    endpoints: [
      {
        name: "api",
        endpoint: API_END_POINT,
        custom_header: async () => {
          return {
            Authorization: `${(await Auth.currentSession()).getAccessToken().getJwtToken()}`,
          };
        },
      },
      {
        name: "geo",
        endpoint: API_END_POINT_GEO,
        custom_header: async () => {
          return {
            Authorization: `${(await Auth.currentSession()).getAccessToken().getJwtToken()}`,
          };
        },
      },
    ],
  },
});

const RoutedPath = (index: number, routeInfo: RouteInfo) => {
  const Layout = routeInfo.layout;
  const Component = routeInfo.component;
  return (
    <Route
      key={`route-${index}`}
      index={routeInfo.index}
      path={routeInfo.path}
      element={<Layout children={<Component />} />}
    />
  );
};

const AuthenticatedRouter = () => {
  const { loggedIn, userProfile } = useAuthContext();
  const routes = getRoutes(loggedIn, userProfile);
  const defaultPath = routes.find((r) => r.index);

  if (!defaultPath) {
    throw Error("No default path defined for this set of routes");
  }
  return (
    <Routes>
      {routes.map((r, index) => RoutedPath(index, r))}
      <Route path="*" element={<Navigate to={defaultPath.path} replace />} />
    </Routes>
  );
};

function App() {
  return (
    <ErrorBoundary>
      <ThemeCustomization>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Locales>
            <ScrollToTop />
            <AuthProvider>
              <AuthenticatedRouter />
            </AuthProvider>
            <ToastContainer position="bottom-left" />
          </Locales>
        </LocalizationProvider>
      </ThemeCustomization>
    </ErrorBoundary>
  );
}

export default App;
